const COUNTRIES = [
  { value: 'VE', label: 'Venezuela' },
  { value: 'AR', label: 'Argentina' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BR', label: 'Brasil' },
  { value: 'CA', label: 'Canadá' },
  { value: 'CL', label: 'Chile' },
  { value: 'CO', label: 'Colombia' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CU', label: 'Cuba' },
  { value: 'DO', label: 'República Dominicana' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'ES', label: 'España' },
  { value: 'US', label: 'Estados Unidos' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'HN', label: 'Honduras' },
  { value: 'MX', label: 'México' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'PA', label: 'Panamá' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Perú' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'AF', label: 'Afganistán' },
  { value: 'AL', label: 'Albania' },
  { value: 'DE', label: 'Alemania' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AG', label: 'Antigua y Barbuda' },
  { value: 'SA', label: 'Arabia Saudita' },
  { value: 'DZ', label: 'Argelia' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaiyán' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Baréin' },
  { value: 'BD', label: 'Bangladés' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BE', label: 'Bélgica' },
  { value: 'BZ', label: 'Belice' },
  { value: 'BJ', label: 'Benín' },
  { value: 'BT', label: 'Bután' },
  { value: 'BY', label: 'Bielorrusia' },
  { value: 'MM', label: 'Birmania' },
  { value: 'BW', label: 'Botsuana' },
  { value: 'BN', label: 'Brunéi' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Camboya' },
  { value: 'CM', label: 'Camerún' },
  { value: 'QA', label: 'Catar' },
  { value: 'TD', label: 'Chad' },
  { value: 'CN', label: 'China' },
  { value: 'CY', label: 'Chipre' },
  { value: 'VA', label: 'Ciudad del Vaticano' },
  { value: 'KM', label: 'Comoras' },
  { value: 'CG', label: 'Congo' },
  { value: 'KP', label: 'Corea del Norte' },
  { value: 'KR', label: 'Corea del Sur' },
  { value: 'CI', label: 'Costa de Marfil' },
  { value: 'HR', label: 'Croacia' },
  { value: 'DK', label: 'Dinamarca' },
  { value: 'DJ', label: 'Yibuti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'EG', label: 'Egipto' },
  { value: 'AE', label: 'Emiratos Árabes Unidos' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'SK', label: 'Eslovaquia' },
  { value: 'SI', label: 'Eslovenia' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Etiopía' },
  { value: 'PH', label: 'Filipinas' },
  { value: 'FI', label: 'Finlandia' },
  { value: 'FJ', label: 'Fiyi' },
  { value: 'FR', label: 'Francia' },
  { value: 'GA', label: 'Gabón' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GD', label: 'Granada' },
  { value: 'GR', label: 'Grecia' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GQ', label: 'Guinea Ecuatorial' },
  { value: 'GW', label: 'Guinea-Bisáu' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haití' },
  { value: 'NL', label: 'Países Bajos' },
  { value: 'HU', label: 'Hungría' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IQ', label: 'Irak' },
  { value: 'IR', label: 'Irán' },
  { value: 'IE', label: 'Irlanda' },
  { value: 'IS', label: 'Islandia' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italia' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japón' },
  { value: 'JO', label: 'Jordania' },
  { value: 'KZ', label: 'Kazajistán' },
  { value: 'KE', label: 'Kenia' },
  { value: 'KG', label: 'Kirguistán' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'LA', label: 'Laos' },
  { value: 'LS', label: 'Lesoto' },
  { value: 'LV', label: 'Letonia' },
  { value: 'LB', label: 'Líbano' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libia' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lituania' },
  { value: 'LU', label: 'Luxemburgo' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MY', label: 'Malasia' },
  { value: 'MW', label: 'Malaui' },
  { value: 'MV', label: 'Maldivas' },
  { value: 'ML', label: 'Malí' },
  { value: 'MT', label: 'Malta' },
  { value: 'MA', label: 'Marruecos' },
  { value: 'MH', label: 'Islas Marshall' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauricio' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldavia' },
  { value: 'MC', label: 'Mónaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NZ', label: 'Nueva Zelanda' },
  { value: 'NE', label: 'Níger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NO', label: 'Noruega' },
  { value: 'OM', label: 'Omán' },
  { value: 'PK', label: 'Pakistán' },
  { value: 'PW', label: 'Palaos' },
  { value: 'PG', label: 'Papúa Nueva Guinea' },
  { value: 'PL', label: 'Polonia' },
  { value: 'RW', label: 'Ruanda' },
  { value: 'RO', label: 'Rumania' },
  { value: 'RU', label: 'Rusia' },
  { value: 'KN', label: 'San Cristóbal y Nieves' },
  { value: 'SM', label: 'San Marino' },
  { value: 'VC', label: 'San Vicente y las Granadinas' },
  { value: 'LC', label: 'Santa Lucía' },
  { value: 'ST', label: 'Santo Tomé y Príncipe' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leona' },
  { value: 'SG', label: 'Singapur' },
  { value: 'SY', label: 'Siria' },
  { value: 'SO', label: 'Somalia' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SZ', label: 'Suazilandia' },
  { value: 'ZA', label: 'Sudáfrica' },
  { value: 'SD', label: 'Sudán' },
  { value: 'SS', label: 'Sudán del Sur' },
  { value: 'SE', label: 'Suecia' },
  { value: 'CH', label: 'Suiza' },
  { value: 'SR', label: 'Surinam' },
  { value: 'TH', label: 'Tailandia' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TJ', label: 'Tayikistán' },
  { value: 'TL', label: 'Timor Oriental' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad y Tobago' },
  { value: 'TN', label: 'Túnez' },
  { value: 'TM', label: 'Turkmenistán' },
  { value: 'TR', label: 'Turquía' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UA', label: 'Ucrania' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UZ', label: 'Uzbekistán' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'WS', label: 'Samoa' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabue' },
];

export default COUNTRIES;
